import { ref } from 'vue'
import {
  judgePatientInGroupAndCompleteInfo,
  queryPatientLatestQuitAndAssistantRemovalStatus
} from '@/api/workPlace/enterpriseWeChatRecord'

const EMPTY_ELIGIBILITY = Object.freeze({
  inGroup: false,
  quitGroupFlag: false,
  completeInfo: false,
  quitDetailLoaded: false,
  quitGroupTime: '',
  deleteAssistantFlag: false,
  deleteAssistantTime: ''
})

/**
 * 独立维护微信患者私聊的准入状态，不参与原有 IM 会话初始化。
 */
export default function useWechatPatientEligibility() {
  const eligibility = ref({ ...EMPTY_ELIGIBILITY })
  const checking = ref(false)
  let requestSerial = 0

  const resetEligibility = () => {
    requestSerial += 1
    checking.value = false
    eligibility.value = { ...EMPTY_ELIGIBILITY }
  }

  const checkEligibility = async ({ ucDoctorId, ucPatientId }) => {
    if (!ucDoctorId || !ucPatientId) {
      resetEligibility()
      return null
    }

    const currentSerial = ++requestSerial
    checking.value = true
    try {
      const result = await judgePatientInGroupAndCompleteInfo({
        bizType: 'DOCTOR_PATIENT',
        ucDoctorId,
        ucPatientId
      })
      if (currentSerial !== requestSerial) return null

      const inGroup = result?.inGroup === true
      const quitGroupFlag = result?.quitGroupFlag === true
      let quitDetail = null
      // 当前仍在群时不查询历史退群明细；仅退群状态需要补充展示信息。
      if (!inGroup && quitGroupFlag) {
        try {
          quitDetail = await queryPatientLatestQuitAndAssistantRemovalStatus({
            bizType: 'DOCTOR_PATIENT',
            ucDoctorId,
            ucPatientId
          })
        } catch (error) {
          // 明细查询失败不影响加群状态，页面降级展示基础退群提示。
          quitDetail = null
        }
      }
      if (currentSerial !== requestSerial) return null
      eligibility.value = {
        inGroup,
        quitGroupFlag,
        completeInfo: result?.completeInfo === true,
        quitDetailLoaded: quitDetail !== null,
        quitGroupTime: quitDetail?.quitGroupTime || '',
        deleteAssistantFlag: quitDetail?.deleteAssistantFlag === true,
        deleteAssistantTime: quitDetail?.deleteAssistantTime || ''
      }
      return eligibility.value
    } catch (error) {
      if (currentSerial !== requestSerial) return null
      eligibility.value = { ...EMPTY_ELIGIBILITY }
      return null
    } finally {
      if (currentSerial === requestSerial) checking.value = false
    }
  }

  return {
    eligibility,
    checking,
    checkEligibility,
    resetEligibility
  }
}
